<template>
  <div class="radio-options-dialog-container" v-if="show">
    <wxc-overlay :left='left' :show="true" :hasAnimation="false"></wxc-overlay>

    <div class="dialog-box" :style="{top:top+'px', left: left+'px', right: right + 'px'}">
      <div
          v-bind:class="{
            'dialog-content-with-cross': showDismissButton,
            'dialog-content-without-cross': !showDismissButton
        }"
      >
        <weex-image
            v-if="showDismissButton"
            class="dialog-cross-image"
            @click="crossClicked"
            :src="crossImage"
        ></weex-image>

        <div v-if="showDismissButton" class="dialog-content-below-cross"></div>

        <weex-text
            v-if="message"
            class="item-sm-heading border-bottom"
            v-html="message"
        ></weex-text>

        <div class="input_container">
          <weex-text
              class="input_label"
              v-if="selectOptionLabel"
              v-html="selectOptionLabel"
          ></weex-text>

          <wxc-radio
              :list="getRadioOptions"
              :config="radioButtonConfig"
              :radio-button-on-right="false"
              :has-bottom-border="false"
              @wxcRadioListChecked="optionSelected"
          ></wxc-radio>
        </div>

        <wxc-button
            :text="continueButtonText"
            size="big"
            class="button_horizontal_center margin_top_20 margin-bottom-20"
            type="blue"
            @wxcButtonClicked="onContinue"
        />


      </div>
    </div>

  </div>
</template>

<script>
import WxcButton from "@/../weex-ui/packages/wxc-button/index"
import WxcOverlay from "@/../weex-ui/packages/wxc-overlay/index"
import WxcRadio from "@/../weex-ui/packages/wxc-radio/index"
import { DefaultResourceConfig, ImageResourcesUtil } from "@/utils/ImageResourcesUtil";
import AlertService from "@/components/core/alert/AlertService";

export default {
  components: { WxcOverlay, WxcButton, WxcRadio },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },

    showDismissButton: {
      type: Boolean,
      default: true
    },

    radioOptions: {
      type: Array,
      required: true,
      default: () => []
    },

    message: {
      type: String,
      required: false,
      default: ""
    },

    selectOptionLabel: {
      type: String,
      required: false,
      default: ""
    },

    continueButtonText: {
      type: String,
      required: false,
      default: "Continue"
    },

    top: {
      type: Number,
      default: 20
    },

    left: {
      type: Number,
      default: 0
    },

    right: {
      type: Number,
      default: 0
    },
  },

  data: () => ({
    selectedOption: ""
  }),

  methods: {
    showToast(message) {
      AlertService.showToast(message);
    },

    crossClicked() {
      this.$emit("onDismissClicked");
    },

    onContinue() {
      if (this.selectedOption) {
        this.$emit('onOptionSelected', this.selectedOption);
      } else {
        this.showToast("Please select valid option.");
      }
    },

    optionSelected(e) {
      this.selectedOption = e.value;
    }
  },

  computed: {
    crossImage() {
      return ImageResourcesUtil.getImageLink(ImageResourcesUtil.CANCEL_RED)
    },

    radioButtonConfig() {
      return DefaultResourceConfig.RADIO_BUTTON;
    },

    getRadioOptions() {
      const options = [];
      this.radioOptions && this.radioOptions.forEach(radioOption => {
        options.push({title: radioOption, value: radioOption});
      });

      return options;

      // if (EzUtils.areEqualString(this.selectedName, this.inputName)) {
      //   nameList[1].checked = true;
      //   nameList[0].checked = false;
      // } else {
      //   this.selectedName = this.panName;
      //   nameList[0].checked = true;
      //   nameList[1].checked = false;
      // }
    }
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

<style scoped>
.radio-options-dialog-container {
  position: fixed;
  z-index: 10000;
}
</style>
